import { ReactNode } from 'react';

import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

import CardDemonstration from './CardDemonstration';
import { If } from '../If';

type Props = {
  allow: boolean;
  children: ReactNode;
  title?: string;
  subTitle?: string;
  labelButton?: string;
  url?: string;
  sx?: SxProps<Theme>;
  subtitleComponent?: ReactNode;
};

function CardDemonstrationBlur({
  allow,
  children,
  title,
  subTitle,
  labelButton,
  url,
  sx,
  subtitleComponent,
}: Props) {
  if (allow) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        minHeight: '300px',
        ...sx,
      }}>
      <If condition={subtitleComponent}>{subtitleComponent}</If>
      <Box
        sx={{
          filter: 'blur(8px)',
          pointerEvents: 'none',
          userSelect: 'none',
          width: '100%',
          height: '100%',
        }}>
        {children}
      </Box>

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          padding: '0 1rem',
          zIndex: 10,
        }}>
        <CardDemonstration
          title={title}
          subTitle={subTitle}
          labelButton={labelButton}
          url={url}
        />
      </Box>
    </Box>
  );
}

export default CardDemonstrationBlur;
